<template>
    <div class="section-dark my-work" id="my-work">
        <div class="container">
            <h1 class="title has-text-centered section-title">Projects
            </h1>
            <div class="subtitle is-4 has-text-centered is-hidden-tablet-only is-hidden-mobile"
                 data-aos="zoom-in" data-aos-delay="2000" data-aos-duration="600" data-aos-once="true">
                Click on a project to find out more!
            </div>

            <div class="columns is-multiline" >
                <div class="column is-4" id="project-ed" v-touch:tap="touchProject('ed')" data-aos="fade-up">
                    <div class="project"
                         @mouseover="showProjectDescription('ed', true)"
                         @mouseleave="showProjectDescription('', false)"
                         @click="showProjectDescription('ed', false)">
                        <div class="project-background image-ed"></div>
                        <div class="image-caption subtitle is-3">EduDoc</div>
                    </div>
                </div>

                <div class="column description-column is-4 is-hidden-tablet-only is-hidden-mobile" id="project-desc"
                     :class="descriptionClass"
                >
                    <div class="title is-4">
                        <span v-if="shownProjectHeadline==='tt'">Täglich Tippen</span>
                        <span v-if="shownProjectHeadline==='az'">Morpheus & Deequ @Amazon</span>
                        <span v-if="shownProjectHeadline==='zw'">Z Webservices</span>
                        <span v-if="shownProjectHeadline==='sy'">Synfioo</span>
                        <span v-if="shownProjectHeadline==='ed'">EduDoc</span>
                    </div>
                    <div class="subtitle is-5 description-text">
                        <span v-if="shownProjectHeadline==='tt'">
                            My first start-up project. A game of luck where people can participate for free and win
                            small rewards.
                        </span>
                        <span v-if="shownProjectHeadline==='az'">
                            I've been working in a team at Amazon research Germany to extend the Big data unit-test
                            library <a href='https://github.com/awslabs/deequ' target="_blank">Deequ</a> and create the
                            data-shift-detection framework <a href=""></a>Morpheus.
                        </span>
                        <span v-if="shownProjectHeadline==='zw'">
                            Freelancing in Software Engineering Projects. My main focus lies on planning
                            designing and implementing Web Apps and personal Websites. If you are interested in working
                            with me, message my <a href="/#about-me">directly</a> or via
                            <a href="/#contact">this form.</a>
                        </span>
                        <span v-if="shownProjectHeadline==='sy'">
                            For <a href="http://www.synfioo.com" target="_blank">Synfioo</a>, a German Start-Up in the
                            logistics industry, I helped creating a full-stack Web-Application. With it, logisticians
                            could track their current transports on a map and gain useful information to
                            assist their planning.
                        </span>
                        <span v-if="shownProjectHeadline==='ed'">
                            My most recent project. On the <a href="http://www.edudoc.de" target="_blank">EduDoc</a>
                            platform, physicians can digitalize their post-universital education process.
                            Currently, we focus on providing infos and a search engine for training courses.
                        </span>
                    </div>
                </div>

                <div class="column is-4"  id="project-az" v-touch:tap="touchProject('az')" data-aos="fade-up">
                    <div class="project"
                         @mouseover="showProjectDescription('az', true)"
                         @mouseleave="showProjectDescription('', false)"
                         @click="showProjectDescription('az', false)">
                        <div class="project-background image-az"></div>
                        <div class="image-caption subtitle is-3">Amazon</div>
                    </div>
                </div>

                <div class="column is-4" id="project-sy" v-touch:tap="touchProject('sy')" data-aos="fade-up">
                    <div class="project"
                         @mouseover="showProjectDescription('sy', true)"
                         @mouseleave="showProjectDescription('', false)"
                         @click="showProjectDescription('sy', false)">
                        <div class="project-background image-sy"></div>
                        <div class="image-caption subtitle is-3">Synfioo</div>
                    </div>
                </div>

                <div class="column is-4" id="project-zw" v-touch:tap="touchProject('zw')" data-aos="fade-up">
                    <div class="project"
                         @mouseover="showProjectDescription('zw', true)"
                         @mouseleave="showProjectDescription('', false)"
                         @click="showProjectDescription('zw', false)">
                        <div class="project-background image-zw"></div>
                        <div class="image-caption subtitle is-3">Z Webservices</div>
                    </div>
                </div>

                <div class="column is-4" id="project-tt" v-touch:tap="touchProject('tt')" data-aos="fade-up">
                    <div class="project"
                         @mouseover="showProjectDescription('tt', true)"
                         @mouseleave="showProjectDescription('', false)"
                         @click="showProjectDescription('tt', false)">
                        <div class="project-background image-tt"></div>
                        <div class="image-caption subtitle is-3">Täglich Tippen</div>
                    </div>
                </div>

            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "Projects",
        data: function () {
            return {
                shownProjectHeadline: "",
                shownProjectDescription: "",
                permanentProjectHeadline: "",
                permanentProjectDescription: "",
                descriptionHintMode: false,
                touchFeedback: "",
                currentProjectName: ""
            }
        },
        methods: {
            touchProject(projectName) {
                let that = this;
                return function (direction, event) {
                    that.showProjectDescription(projectName, false);
                }
            },
            showProjectDescription(projectName, isHintMode) {
                this.descriptionHintMode = isHintMode;
                if (!isHintMode) {
                    if (projectName) {
                        this.permanentProjectHeadline = projectName;
                        this.permanentProjectDescription = projectName;
                    }
                }
                if (projectName) {
                    this.shownProjectHeadline = projectName;
                    this.shownProjectDescription = projectName;
                    this.currentProjectName = projectName;
                } else {
                    this.shownProjectHeadline = this.permanentProjectHeadline;
                    this.shownProjectDescription = this.permanentProjectDescription;
                }
            },
        },
        computed: {
            descriptionClass() {
                let classReturns = [];
                if(screen.width <= 768) {
                    switch (this.currentProjectName) {
                        case "ed":
                            classReturns.push("pos-1");
                            break;
                        case "az":
                            classReturns.push("pos-2");
                            break;
                        case "sy":
                            classReturns.push("pos-3");
                            break;
                        case "zw":
                            console.log("z webservices is klicked")
                            classReturns.push("pos-4");
                            break;
                        case "tt":
                            classReturns.push("pos-5");
                            break;
                    }
                }
                if(this.descriptionHintMode)
                    classReturns.push('hint-mode')

                return classReturns;
            }
        }
    }
</script>

<style scoped>

    .description-column {
        order: 1;
    }

    @media (max-width: 768px) {
        .columns.is-multiline {
            display: flex;
            flex-direction: column;
        }

    }


    .description-column.pos-0 {
        order: 0;
    }

    .description-column.pos-1 {
        order: 2;
    }

    .description-column.pos-2 {
        order: 4;
    }

    .description-column.pos-3 {
        order: 6;
    }

    .description-column.pos-4 {
        order: 8;
    }

    .description-column.pos-5 {
        order: 10;
    }

    #my-work {
        display: flex;
    }

    #project-ed {
        order: 1;
    }

    #project-az {
        order: 3;
    }

    #project-sy {
        order: 5;
    }

    #project-zw {
        order: 7;
    }

    #project-tt {
        order: 9;
    }



    .image-tt {
        background: linear-gradient(rgba(62, 62, 6, 0.22), rgba(232, 232, 232, 0.24)), rgba(0, 0, 0, 0.55) url("../assets/clover.jpg") no-repeat;
        background-size: cover;
        -webkit-filter: grayscale(100%); /* Safari 6.0 - 9.0 */
        filter: grayscale(100%);
    }

    .image-az {
        background: linear-gradient(rgba(62, 62, 6, 0.22), rgba(232, 232, 232, 0.24)), rgba(0, 0, 0, 0.55) url("../assets/dataScience.jpg") no-repeat;
        background-size: cover;
        -webkit-filter: grayscale(100%); /* Safari 6.0 - 9.0 */
        filter: grayscale(100%) brightness(80%);
    }

    .image-sy {
        background: linear-gradient(rgba(62, 62, 6, 0.22), rgba(232, 232, 232, 0.24)), rgba(0, 0, 0, 0.55) url("../assets/logistics.jpg") no-repeat;
        background-size: cover;
        -webkit-filter: grayscale(100%); /* Safari 6.0 - 9.0 */
        filter: grayscale(100%);
    }

    .image-zw {
        background: linear-gradient(rgba(62, 62, 6, 0.22), rgba(232, 232, 232, 0.24)), rgba(0, 0, 0, 0.55) url("../assets/webservices.jpg") no-repeat;
        background-size: cover;
        -webkit-filter: grayscale(100%); /* Safari 6.0 - 9.0 */
        filter: grayscale(100%);
    }

    .image-ed {
        background: linear-gradient(rgba(62, 62, 6, 0.22), rgba(232, 232, 232, 0.24)), rgba(0, 0, 0, 0.55) url("../assets/uncompressed/Hintergrund-cut.jpg") no-repeat;
        background-size: cover;
        -webkit-filter: grayscale(100%); /* Safari 6.0 - 9.0 */
        filter: grayscale(100%);
    }

    .project {
        position: relative;
        cursor: pointer;
        height: 12.5rem;
        width: 100%;
        transition: all .5s ease-in-out;

        display: flex;
        justify-content: center;
    }

    .project:hover {
        transform: scale(1.05);
    }

    .project-background {
        border-radius: 5px;
        position: absolute;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        filter: brightness(90%);
        z-index: 0;
    }

    .image-caption {
        display: flex;
        align-items: center;
        justify-content: center;
        color: white;
        filter: brightness(100%);
    }

    .image-tt {

    }

    .hint-mode {
        filter: opacity(0.1);
    }


    .title.section-title {
        margin-bottom: 0 !important;
    }


</style>
